"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.AEValidator = exports.AEValidatorKeys = void 0;
const echain_shared_validation_1 = require("@igus/echain-shared-validation");
const echain_shared_articles_1 = require("@igus/echain-shared-articles");
// prettier-ignore
var AEValidatorKeys;
(function (AEValidatorKeys) {
    AEValidatorKeys["moreThanTwoPresent"] = "AEValidator: more than 2 AEs are present";
    AEValidatorKeys["invalidApplicationPairing"] = "AEValidator: invalid application pairing";
    AEValidatorKeys["notSet"] = "AEValidator: aes are not set";
    AEValidatorKeys["invalidPair"] = "AEValidator: ae is not a valid pair";
    AEValidatorKeys["applicationFlags"] = "AEValidator: invalid application flags";
    AEValidatorKeys["aesDespiteHasNoAE"] = "AEValidator: aes despite hasNoAE flag set to true";
})(AEValidatorKeys = exports.AEValidatorKeys || (exports.AEValidatorKeys = {}));
class AEValidator {
    /**
     * Validates if a single AE is a Komplettsatz (meaning representing two AEs).
     */
    static isAEKomplettSatz(ae, keyPrefix) {
        if (!keyPrefix)
            keyPrefix = '';
        const expression = Boolean((ae.komplettsatzGerade || ae.komplettsatzUngerade) && ae.application === echain_shared_articles_1.AEApplication.satz);
        return echain_shared_validation_1.Validation.create(expression, keyPrefix + AEValidatorKeys.invalidPair);
    }
    /**
     * At least one 'Festpunkt' and 'Mitnehmer' must be set.
     *
     * If one ae can only be 'Festpunkt', the other must be able to be 'Mitnehmer', and vice versa.
     *
     * If one ae can only be 'Mitnehmer', the other must be able to be 'Festpunkt', and vice versa.
     *
     * This is not what the `AE` __is__ used as but just the possibilities the `AE` __could__ be used as.
     */
    static validApplicationFlags(aes, keyPrefix) {
        if (!keyPrefix)
            keyPrefix = '';
        const ae1 = aes[0];
        const ae2 = aes[1];
        const festpunktA = ae1.festpunktGerade || ae1.festpunktUngerade;
        const festpunktB = ae2.festpunktGerade || ae2.festpunktUngerade;
        const mitnehmerA = ae1.mitnehmerGerade || ae1.mitnehmerUngerade;
        const mitnehmerB = ae2.mitnehmerGerade || ae2.mitnehmerUngerade;
        // all flags can be set, so we need to determine which are missing and if the other AE can
        // offer the missing one
        if (!festpunktA && !mitnehmerA)
            return echain_shared_validation_1.Validation.fail(keyPrefix + AEValidatorKeys.applicationFlags);
        if (!festpunktB && !mitnehmerB)
            return echain_shared_validation_1.Validation.fail(keyPrefix + AEValidatorKeys.applicationFlags);
        // at least one festpunkt and one mitnehmer must be possible
        if ((festpunktA && mitnehmerB) || (festpunktB && mitnehmerA))
            return echain_shared_validation_1.Validation.success();
        return echain_shared_validation_1.Validation.fail(keyPrefix + AEValidatorKeys.applicationFlags);
    }
    /**
     * Validates if one ae is used as 'Mitnehmer' and the other is used as 'Festpunkt'.
     *
     * This differs from `validApplicationFlags` because application flags are what AE __could be used as__.
     *
     * Application means, what the AE __is used as__.
     */
    static validApplication(aes, keyPrefix) {
        if (!keyPrefix)
            keyPrefix = '';
        const ae1 = aes[0];
        const ae2 = aes[1];
        const anyAEisKomplettsatz = ae1.application === echain_shared_articles_1.AEApplication.satz || ae2.application === echain_shared_articles_1.AEApplication.satz;
        if (anyAEisKomplettsatz) {
            return echain_shared_validation_1.Validation.fail(keyPrefix + AEValidatorKeys.invalidApplicationPairing);
        }
        const validApplication = !!ae1.application && !!ae2.application && ae1.application !== ae2.application;
        return echain_shared_validation_1.Validation.create(validApplication, keyPrefix + AEValidatorKeys.invalidApplicationPairing);
    }
}
exports.AEValidator = AEValidator;
//# sourceMappingURL=AEValidator.js.map